import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="M3 2h10L7.99 8.3zM.25 1.61C2.27 4.2 6 9 6 9v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V9s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H1.04C.21 0-.26.95.25 1.61" />
, 'ActionFilterOutlinedx');
